<template>
  <v-card>
    <v-layout justify-center>
      <!--タイトル-->
      <v-card-title class="head">
        {{ title }}
        <v-icon color="indigo">
          {{ icon }}
        </v-icon>
      </v-card-title>
    </v-layout>
    <Summary></Summary>
    <!--学会発表-->
    <Announcing></Announcing>
    <!--お問い合わせ-->
    <contact></contact>
  </v-card>
</template>

<script>
import Summary from './Summary'
import Announcing from './Announcing'
import contact from '../contact'

export default {
  data () {
    return {
      title: '研究開発',
      icon: 'mdi-lightbulb'
    }
  },
  components: {
    Summary,
    Announcing,
    contact
  }
}
</script>
